<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="
                $t('administration.mobile_feature.notification.schedule.search')
              "
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.notification_type.not_type }}</td>
          <td class="text-center">{{ record.num_day_alert }}</td>
          <td>{{ $store.getters.limitStringShow(record.comment) }}</td>
          <td class="text-center">
            <span v-if="record.inactive"
              ><i class="far fa-check-square text-primary"></i
            ></span>
            <span v-else><i class="far fa-window-close text-danger"></i></span>
          </td>
          <td class="text-center">
            <a
              href="#"
              class="mr-2 text-primary"
              v-tooltip="$t('edit')"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'data-table',
  props: ['fetch'],
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('notificationSchedule', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.notificationSchedule.search
      },
      set(newValue) {
        this.$store.commit('notificationSchedule/SET_SEARCH', newValue)
        this.$store.commit('notificationSchedule/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t(
            'administration.mobile_feature.notification.schedule.notification_type'
          ),
          style: 'width: 30%;'
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.schedule.notify_before'
          ),
          style: 'width: 30%; text-align:center'
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.schedule.comment'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.schedule.inactive'
          ),
          style: 'text-align:center;'
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.schedule.actions'
          ),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('notificationSchedule/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    edit(record) {
      let { ...resource } = record
      this.$store.commit('notificationSchedule/SET_EDIT_DATA', resource)
      this.$router.push({
        name: 'notification-schedule-edit',
        params: { id: record.not_sch_id }
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),

    fetch: function(value) {
      if (value) {
        this.fetchData()
        this.$emit('fetched')
      }
    }
  }
}
</script>
